(() => {
  const sectionSelector = '.facest-filters-section';
  document.documentElement.setAttribute('data-tesevo-collection-enhancements', 'active');

  const setSidebarStacking = (section, isOpen) => {
    section?.querySelector('.m-collection--wrapper')?.classList.toggle('tesevo-sidebar-active', isOpen);
  };

  const openSidebar = (section, trigger) => {
    const sidebar = section?.querySelector('.m-sidebar');
    const content = sidebar?.querySelector('.m-sidebar--content');
    if (!sidebar || !content) return;

    section.tesevoSidebarTrigger = trigger || section.querySelector('.m-sidebar--open');
    section.tesevoSidebarTrigger?.setAttribute('aria-expanded', 'true');
    sidebar.style.display = 'block';
    sidebar.setAttribute('aria-hidden', 'false');
    section.classList.add('sidebar-open');
    setSidebarStacking(section, true);
    document.documentElement.style.overflow = 'hidden';

    window.requestAnimationFrame(() => {
      sidebar.style.setProperty('--m-bg-opacity', '0.5');
      content.style.setProperty('--m-translate-x', '0');
      content.querySelector('.m-sidebar--close')?.focus({ preventScroll: true });
    });
  };

  const closeSidebar = (section) => {
    const sidebar = section?.querySelector('.m-sidebar');
    const content = sidebar?.querySelector('.m-sidebar--content');
    if (!sidebar || !content) return;

    section.classList.remove('sidebar-open');
    setSidebarStacking(section, false);
    section.tesevoSidebarTrigger?.setAttribute('aria-expanded', 'false');
    sidebar.style.removeProperty('--m-bg-opacity');
    content.style.setProperty('--m-translate-x', '-100%');
    document.documentElement.style.removeProperty('overflow');

    window.setTimeout(() => {
      if (!section.classList.contains('sidebar-open')) {
        sidebar.style.removeProperty('display');
        sidebar.setAttribute('aria-hidden', 'true');
        section.tesevoSidebarTrigger?.focus({ preventScroll: true });
      }
    }, 300);
  };

  const openMobileSorting = () => {
    const wrapper = document.querySelector('.m-sortby-mobile--wrapper');
    const content = wrapper?.querySelector('.m-sortby-mobile--content');
    if (!wrapper || !content) return;

    wrapper.style.display = 'block';
    wrapper.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    window.requestAnimationFrame(() => {
      wrapper.style.setProperty('--m-bg-opacity', '0.5');
      content.style.setProperty('--m-translate-y', '0');
    });
  };

  const closeMobileSorting = () => {
    const wrapper = document.querySelector('.m-sortby-mobile--wrapper');
    const content = wrapper?.querySelector('.m-sortby-mobile--content');
    if (!wrapper || !content) return;

    wrapper.style.setProperty('--m-bg-opacity', '0');
    content.style.setProperty('--m-translate-y', '100%');
    document.documentElement.style.removeProperty('overflow');

    window.setTimeout(() => {
      wrapper.style.display = 'none';
      wrapper.setAttribute('aria-hidden', 'true');
    }, 300);
  };

  document.addEventListener('click', (event) => {
    const sortButton = event.target.closest(`${sectionSelector} .m-sortby--open`);
    if (sortButton) {
      window.requestAnimationFrame(() => {
        const wrapper = document.querySelector('.m-sortby-mobile--wrapper');
        if (wrapper && getComputedStyle(wrapper).display === 'none') openMobileSorting();
      });
      return;
    }

    const closeSortButton = event.target.closest('.m-sortby-mobile--close');
    if (closeSortButton) {
      closeMobileSorting();
      return;
    }

    const sortWrapper = event.target.closest('.m-sortby-mobile--wrapper');
    if (sortWrapper && event.target === sortWrapper) {
      closeMobileSorting();
      return;
    }

    const openButton = event.target.closest(`${sectionSelector} .m-sidebar--open`);
    if (openButton) {
      const section = openButton.closest(sectionSelector);
      if (section) section.tesevoSidebarTrigger = openButton;
      openButton.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => {
        const sidebar = section?.querySelector('.m-sidebar');
        if (sidebar && getComputedStyle(sidebar).display === 'none') openSidebar(section, openButton);
        if (sidebar && getComputedStyle(sidebar).display !== 'none') {
          sidebar.setAttribute('aria-hidden', 'false');
          setSidebarStacking(section, true);
          document.documentElement.style.overflow = 'hidden';
          sidebar.querySelector('.m-sidebar--close')?.focus({ preventScroll: true });
        }
      });
      return;
    }

    const closeButton = event.target.closest(`${sectionSelector} .m-sidebar--close`);
    if (closeButton) {
      closeSidebar(closeButton.closest(sectionSelector));
      return;
    }

    const sidebar = event.target.closest(`${sectionSelector} .m-sidebar`);
    if (sidebar && event.target === sidebar) closeSidebar(sidebar.closest(sectionSelector));
  }, { capture: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openSection = document.querySelector(`${sectionSelector}.sidebar-open`);
    if (openSection) closeSidebar(openSection);
    const sortingWrapper = document.querySelector('.m-sortby-mobile--wrapper');
    if (sortingWrapper && getComputedStyle(sortingWrapper).display !== 'none') closeMobileSorting();
  });

  const updateModelNav = (nav) => {
    const list = nav.querySelector('.tesevo-model-nav__list');
    const button = nav.querySelector('.tesevo-model-nav__more');
    if (!list || !button) return;

    const isScrollable = list.scrollWidth > list.clientWidth + 4;
    const isAtEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 6;
    nav.classList.toggle('is-scrollable', isScrollable);
    nav.classList.toggle('is-at-end', isAtEnd);
    button.hidden = !isScrollable || isAtEnd;
  };

  const scheduleModelNavUpdate = (nav) => {
    window.cancelAnimationFrame(nav.tesevoModelNavFrame);
    window.clearTimeout(nav.tesevoModelNavTimer);

    nav.tesevoModelNavFrame = window.requestAnimationFrame(() => {
      nav.tesevoModelNavFrame = window.requestAnimationFrame(() => updateModelNav(nav));
    });
    nav.tesevoModelNavTimer = window.setTimeout(() => updateModelNav(nav), 250);
  };

  const initModelNav = (nav) => {
    if (nav.dataset.tesevoModelNavReady === 'true') {
      scheduleModelNavUpdate(nav);
      return;
    }

    nav.dataset.tesevoModelNavReady = 'true';
    const list = nav.querySelector('.tesevo-model-nav__list');
    const button = nav.querySelector('.tesevo-model-nav__more');
    if (!list || !button) return;

    button.addEventListener('click', () => {
      list.scrollBy({ left: Math.max(180, list.clientWidth * 0.72), behavior: 'smooth' });
    });
    list.addEventListener('scroll', () => scheduleModelNavUpdate(nav), { passive: true });

    if ('ResizeObserver' in window) {
      nav.tesevoModelNavResizeObserver = new ResizeObserver(() => scheduleModelNavUpdate(nav));
      nav.tesevoModelNavResizeObserver.observe(nav);
      nav.tesevoModelNavResizeObserver.observe(list);
    }

    scheduleModelNavUpdate(nav);
    document.fonts?.ready.then(() => scheduleModelNavUpdate(nav));
  };

  const initModelNavs = () => {
    document.querySelectorAll('[data-tesevo-model-nav]').forEach(initModelNav);
  };

  initModelNavs();
  window.addEventListener('load', initModelNavs, { once: true });
  window.addEventListener('pageshow', initModelNavs);
  window.addEventListener('resize', initModelNavs, { passive: true });
})();
